// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"8":"form-work","79":"news-view","322":"bottom","500":"product-view","521":"video-view","667":"regard","752":"relation-view"}[chunkId] + "." + {"8":"85e727ef","79":"0368aaa6","322":"2fb1705f","500":"8a53c2da","521":"8eed64c2","667":"cbde430c","752":"91d3ccc3"}[chunkId] + ".css";
};